import {
    defineStore,
} from 'pinia';
import {
    ref,
} from 'vue';

const SNACKBAR_LIFETIME = 3000; // Animation is 2200ms, directed by global styles.

export const useSnackbar = defineStore('snackbar', () => {
    const snackbarData = ref(null);

    let clearTimer = null;
    const showSnackbar = (props) => {
        if (clearTimer !== null) return;
        snackbarData.value = props;
        clearTimer = setTimeout(() => {
            snackbarData.value = null;
            clearTimer = null;
        }, SNACKBAR_LIFETIME);
    };

    return {
        snackbarData,
        showSnackbar,
    };
});
